// eslint-disable-next-line import/no-anonymous-default-export
export default {
  language: 'ja',
  base: {
    back_btn: 'HOMEへ戻る',
    email: 'メールアドレス',
    password: 'パスワード',
    confirm: '確認',
    tCO2e: 'tCO2e',
    cancel: 'キャンセル',
    cancel2: 'キャンセル',
    add: '追加する',
    add2: '追加',
    update: '更新',
    update2: '更新',
    upload: 'アップロード',
    logout: 'ログアウト',
    do_you_want_to_logout: 'ログアウトしますか。',
    all: 'すべて',
    no_data_to_display:
      '表示するデータがありません。\nデータを登録して、もう一度確認してください。',
    delete: '削除',
    delete_short: '削除',
    no_items: '表示するデータがありません。',
    add_new_option: '新規作成：',
    chart_sp:
      'このチャートを見るには、デバイスを横向きに回転させるか、タブレットまたは PCで見てください。',
    required: '必須',
    optional: '任意',
    no_result_found: '結果が見つかりません。',
    yen: '円',
    usd: '$',
    menu: 'メニュー',
    unit: '単位',
    user_guide: '利用ガイド',
    select_all_options: 'すべて選択',
    scope_1_cost_trends_by_fuel_types: 'スコープ1の燃料費調整額の推移',
    cost_trends_by_fuel_types: '燃料費の推移',
    enter_character_to_search: '文字を入力して検索',
    placeholder_manual_input: '４Fの電気、社長の車など',
    noti_upload_image:
      '※このシステムはプレミアムプランのみ使用可能です。画像や書類管理が可能です。',
    type_input: '入力を始める',
    search: '検索',
    view_analysist: '分析を表示する',
    close: '閉じる',
    year: '年度',
    back_to_default: '戻る',
    search_by_condition: '条件で検索する',
    close_by_condition: '条件検索を閉じる',
    reload: '再読み込み',
    option_default: {
      all: '全て',
      electricity: '他社から供給された電気の使用',
    },
    change: '変更する',
    loading: '読み込み中...',
    load_more: 'もっと見る',
    mark_as_read: '既読にする',
    approve: '承認する',
    back_to_prev: '前へ戻る',
    back_to_previous_page: '前へ戻る',
    detail: '内訳',
    new_addition: '新規追加',
    clear_conditions: 'フィルターを外す',
    choice: '保存したフィルタを選択',
    save: '保存',
    filter: 'フィルター名',
    new: 'フィルター',
    draft: '下書き',
    result: '結果',
    confirm_download_csv:
      '指定した条件でCSVの出力を開始しますか？<br></br>※スコープ1〜3が全て出力されます。',
    download: 'はい',
    export_csv: 'CSVで出力',
    request: 'リクエスト',
    status: 'ステータス',
    scope: 'スコープ',
    ok: 'OK',
    total: 'CO2排出量合計値',
    year_number: '{{year}}年',
    done: '終わり',
    clear: 'クリア',
    unique: '独自',
    edit: '編集',
    copy: '複製',
    view: '閲覧',
    file: 'ファイル',
    send: '送信',
    calculate_year: '算定年度',
    save_filter: 'フィルターを保存',
    kudan: '{{quantity}} 件',
    pin_this: 'ピン留めする',
    unpin: 'ピン留めを解除する',
    can_not_pin: '最大で4つまでピン留めできます',
    title_filter: 'フィルターの設定',
    unique_coefficient: '独自係数',
    add_row_btn: '行を追加する',
    preview: 'プレビュー',
  },
  login: {
    login: 'ログイン',
    policy: 'プライバシーポリシー',
    copy_right: '© 2023 tansomanGX Co., Ltd.',
    forgot_password: 'パスワードをお忘れですか?',
    save_login: 'ログイン状態を保存する',
    register_account: 'アカウント作成はこちら',
    dont_have_account: 'アカウントを持っていませんか？',
    please_enter_email: 'メールアドレスを入力してください。',
    go_to_forgot_password: 'パスワード再設定はこちら',
    do_not_have_account: 'アカウントをお持ちでない方',
    go_to_register: 'アカウント作成はこちら',
  },
  nav: {
    data: 'ホーム',
    analysis: '分析',
    all: '組織の総排出量',
    scope1: 'スコープ1',
    scope2: 'スコープ2',
    scope3: 'スコープ3',
    other_analysis: 'その他',
    other_analysis_full: 'その他の分析',
    report: 'レポート',
    emissions: '排出量',
    registration: '登録',
    register_emissions: '排出量を登録する',
    list_of_registration: '排出量登録',
    emission_intensity: '排出原単位',
    facility_management: '施設／拠点',
    base_management: '拠点管理',
    my_account: 'アカウント',
    settings: '設定',
    image_management: '画像ファイル管理',
    change_password: 'パスワード変更',
    change_usage_plan: '利用プラン変更',
    help: 'ヘルプ',
    user_guide: '利用ガイド',
    faq: 'よくあるご質問',
    contact_us: 'お問い合せ',
    tutorial: 'チュートリアル',
    other: 'その他',
    logout: 'ログアウト',
    notifications: 'お知らせ',
    user_management_title: 'ユーザー権限管理',
    subsidy: 'ファイル',
    company_setting: '組織設定',
    linkage_management: '連携管理',
    request_management: '連携企業一覧',
    shared_emissions: '連携状況管理',
    premium: 'Premium',
    goal_setting: '削減目標',
    representative: '業務代行',
    cutoff_demo: '完成のデモページ',
    versions: '削減数値設定',
    cutoff: '削減対策計画',
    simulation: '削減予測イメージ',
    emission_policy: '排出原単位ポリシー',
    history_title: 'インポートしたデータは下の一覧からダウンロードできます。',
  },
  sub_title: {
    register_emissions:
      '自社が購入・取得した製品またはサービスの物量・金額データを入力しましょう。',
    list_of_registration: '組織の排出量を管理できます。',
    list_of_registration_refer:
      '登録項目が不明な場合はこちらの<a>用語集</a>を参照してください。',
    analysis: {
      all: '登録した組織や各施設／拠点状況をスコープ別に閲覧できます。データをみてCO2排出量を分析してみましょう。',
      scope1:
        '登録した組織や各施設／拠点状況をスコープ別に閲覧できます。データをみてCO2排出量を分析してみましょう。',
      scope2:
        '登録した組織や各施設／拠点状況をスコープ別に閲覧できます。データをみてCO2排出量を分析してみましょう。',
      scope3:
        '登録した組織や各施設／拠点状況をスコープ別に閲覧できます。データをみてCO2排出量を分析してみましょう。',
    },
    emission_intensity:
      'このページではスコープごとにタンソチェックで提供している排出係数を検索することができます。',
    branch:
      'タンソチェックは、企業の活動量データを拠点ごとに入力して、CO2排出量の算定を行います。まずは拠点登録からはじめ、各施設ごとに管理・分析ができるようにしましょう。',
    user: 'ユーザーの管理・閲覧制限、追加ができます。',
    subsidy:
      'こちらでフォルダーを作成し、ファイル管理をすることができます。Excelのファイル形式はアップロードできます。',
    csv_input:
      '自社が購入・取得した製品またはサービスの物量・金額データをExcelデータを使って一括で登録しましょう。',
    other_company_data:
      '連携した他の組織の排出量データの詳細を確認することができます',
    sub_emission_policy:
      'こちらではタンソチェックで利用されている排出係数のソースについて説明しています。',
    check_and_edit_uploaded_data: 'アップロードデータの確認・編集',
    select_data_to_upload: 'アップロードデータの選択',
  },
  languages: {
    jp: '日本語',
    en: 'English',
  },
  message: {
    change_password_success: 'パスワードを変更しました',
    please_upload_five_files: 'ファイルは5個まで選択してください。',
    please_upload_five_folder_files:
      '一括のアップロード数は5ファイルになります。',
    max_size_upload:
      'ファイルサイズが10MBを超えてます。10MB以下でアップロードしてください。',
    max_size_storage:
      'アップロードに失敗しました。\n容量を超えています。空き容量を増やしてもう一度試してください。',
    max_length_folder_file_name:
      'ファイル名は{{length}}文字以内のみアップロードができます。',
    unsupported_file_extentions_upload:
      'Excel形式のファイルをアップロードしてください',
    unsupported_file_extentions:
      'JPEG・PNG・JPG・JFIF・HEIC・PDF形式を選択してください。',
    unsupported_file_size: '1ファイルあたりの最大サイズは10MBです。',
    require: 'この項目に入力してください。',
    max_value_input_number: '9桁以下で入力してください。',
    email_already_exist: 'このメールアドレスは既に登録されています。',
    email_invalid: 'メールアドレスは正しい形式ではありません。',
    phone_invalid: '直通の電話番号は正しい形式ではありません。',
    duplicate_email: 'このメールアドレスは既に登録されています。',
    invalid_password:
      '半角英文字・半角数字をそれぞれ1種類以上含む8文字以上で入力してください。\n入力可能な記号：@#$!%^*?&()-=_+',
    invalid_login_password: 'メールアドレス又はパスワードが正しくありません。',
    invalid_regex_password:
      '半角英文字・半角数字をそれぞれ1種類以上含む8文字以上で入力してください。\n入力可能な記号：@#$!%^*?&()-=_+',
    invalid_password_registration_user:
      '半角英文字・半角数字をそれぞれ1種類以上含む8文字以上で入力してください。\n入力可能な記号：@#$!%^*?&()-=_+',
    clear_password:
      'パスワードを変更する前に、現在のパスワードをクリアする必要があります。',
    email_not_exist: 'メールアドレスが正しくありません。',
    incorrect_login: 'メールアドレス又はパスワードが正しくありません。',

    faild_invalid: '必須項目を入力してください。',
    faild_number: '活動量は正しい形式ではありません',
    current_password_invalid: '現在のパスワードが正しくありません。',
    user_inactive: '無効なアカウントです。再度ご確認ください。',
    no_option: '選択肢がありませんので、新規で文字入力をしてください',
    empty_notification: 'お知らせはありません。',
    delete_permanently: 'ファイルを完全に削除しました',
    restore_file: '{{fileName}} を復元しました。',
    empty_folder_table: '表示するデータがありません。',
    branch_exist: '拠点は既に存在します。',
    add_data_success: 'データを追加しました。',
    register_user_success: '登録したメールアドレス宛に案内がお送りされました。',
    update_data_success: 'データを更新しました。',
    register_data_success: 'データの登録に成功しました。',
    division_exist: '事業部は既に存在しています。',
    company_exist: '組織はは既に存在しています。',
    user_not_found: 'ユーザーは存在していません。',
    user_activated: 'ユーザーは存在していません。',
    resend_email_success: 'メールの再送信に成功しました',
    token_invalid: 'トークンのが無効です。',
    branch_not_found: '拠点は存在していません。',
    emission_not_found: '排出原単位は存在していません。',
    register_data_not_found: '排出量は存在していません。',
    delete_success: '削除しました。',
    password_not_match: 'パスワードが一致しません',
    company_not_match: '該当の組織がないため、別の組織コードをご入力ください。',
    company_request_exist: '該当の組織が連携しています。',
    company_collaboration_exist: '該当組織連携の申請が承認しました。',
    unshared_data_success: 'データは正常に共有解除されました。',
    search_condition_existed: '検索条件名はすでに存在します',
    save_data_success: 'データの保存に成功しました',
    request_share_is_existed: 'この情報のリクエストが既に存在しています。',
    invalid_number: '0以上で入力してください',
    invalid_format_number:
      '小数点前は最大10桁、小数点後は1桁までの数字を入力してください。',
    approve_successfull: '承認成功',
    please_upload_file: 'ファイルをアップロードしてください',
    not_have_facilities: '拠点登録がありません。',
    update_group_successful: 'グループを正常に更新しました',
    register_fiscal_year_start_month:
      '年度開始月：{{month}}月 [<style>編集</style>]',
    please_input_this_field: 'この項目に入力してください。',
    duplicate_success: '複製しました。',
    base_year_not_set:
      '基準年度はまだ設定していません。基準年度を設定してください。',
    can_not_be_empty: 'この項目に入力してください。',
    version_not_found: 'バージョンが見つかりません',
    version_name_exist: 'バージョン名は既に存在します。',
    can_not_update_base_year: '※基準年度は設定されたら更新できません。',
    confirm_save_base_year:
      '基準年度は変更ができません。こちらで確定してもよろしいでしょうか？',
    no_data: 'データが存在しません',
    enter_number_greater_than: '{{number}}より大きい数字を入力してください。',
    item_exist: '品目が既に存在しています。',
    token_expired: 'トークンの有効期限が切れました',
    half_width_number: '半角数字で入力してください。',
    invite_success: '連携を送信しました。',
    total_emission_is_not_entered:
      '基準年度の総排出量 [tCO2e]がまだ入力されていません。こちらの入力をしてから削減目標を立てましょう！',
    warning_change_financial_month:
      '※開始月を変更すると、自社の独自係数が正しく参照できない、または参照できなくなる可能性があります。',
    not_be_referenced: 'この係数は存在しないか、または変更されています。',
    copy_emission_reselect:
      '複製元の係数は現在ご利用いただけないため、係数の選択を解除しました。お手数ですが選び直してください。',
    copy_item_reselect:
      '複製元の項目は、選択中の拠点・年月ではご利用いただけないため、選択を解除しました。お手数ですが選び直してください。',
    validation: {
      activity_amount_too_large:
        '活動量の値が大きすぎます。より小さい値を入力してください。',
    },
    confirm_delete_emission_title:
      '独自係数を削除しますが、よろしいでしょうか。',
    confirm_delete_emission_checkbox:
      '独自係数が登録されているため、排出量データがなくなります。',
    warning_change_scope:
      '入力中のデータがあります。このままタブを移動すると、入力内容が失われます。よろしいですか？',
    confirm_delete_branch_title: '拠点を削除しますが、よろしいでしょうか。',
    confirm_delete_branch_checkbox:
      '拠点に排出量データが登録されているため、排出量データがなくなります。',
  },
  forgot_password: {
    forgot_password: 'パスワードをお忘れの方へ',
    description_top:
      'パスワードをリセットするために登録されているメールアドレスが必要となります。',
    description_bottom:
      'メールアドレスを入力し、送信ボタンを押すと確認用のメールが届きますので、それに従ってパスワードのリセット処理を行ってください。',
    email_address: 'メールアドレス',
    please_enter_email: 'メールアドレスを入力してください',
    send: '送信',
    back_to_login: 'ログインへ戻る',
    send_mail_success:
      'パスワードリセットのリクエストを受け付けました。\nご入力いただいたメールアドレスが登録されており、アカウントがアクティブな場合、パスワードリセットの手順を記載したメールを送信します。',
  },
  resend_verify_account: {
    title: '認証メール再送付',
    description: '{{ email }}に認証メールを再送付しますか?',
  },
  reset_password: {
    change_password: 'パスワード変更',
    description: '新しいパスワードを入力してください',
    new_password: '新しいパスワード',
    confirm_password: 'パスワードを認証する',
    change: '変更',
    password_not_match: '入力したパスワードと一致していません。',
    message_success: 'パスワード変更が完了しました。\n再ログインしてください',
  },
  sidebar: {
    drop_invoices: 'ここに請求書や領収書をドロップしてアップロード',
    or: 'または',
    or2: 'または',
    select_file: 'ファイル選択する',
    select_a_file: 'ファイル選択する',
  },
  dashboard: {
    home: {
      eyebrow: 'Organization overview',
      title: '組織全体の排出量',
      kpi_aria: '主要指標',
      total: '総排出量',
      scope1: 'Scope 1',
      scope2: 'Scope 2',
      scope3: 'Scope 3',
      month: '月',
      fiscal_year: '年度',
      previous_year: '前年',
      previous_short: '前年',
      share_short: '構成比',
      vs_previous_year: '前年比',
      vs_same_period: '前年同期比',
      ytd_short: '同期',
      in_progress: '算定中',
      data_through: '{{month}}まで集計（{{count}}ヶ月分）',
      monthly_title: '月別排出量の推移',
      branches_title: '拠点別排出量',
      top_n_of: '上位{{n}} / 全{{total}}拠点',
      goal_title: '削減目標の進捗',
      annual_title: '年度別の推移',
      categories_title: 'Scope 3 カテゴリ内訳',
      sources_title: '主要な排出源',
      sources_note: 'Scope 1・2 の項目別',
      table_title: '年度別サマリー（数表）',
      annual_note: '{{year}}は算定中のため、ここまでの集計値を表示しています。',
      table_note:
        '（ ）内は前年度比。Scope 2 は上部で選択した係数（マーケット / ロケーション）で集計しています。',
      view_detail: '詳しく見る',
      view_all: 'すべて見る',
      no_data: 'データがありません',
      no_branch: '拠点未設定',
      other: 'その他',
      goal: {
        premium_only: '削減目標の管理はプレミアムプランでご利用いただけます。',
        not_set: '削減目標がまだ設定されていません。',
        set_goal: '目標を設定する',
        achieved: '達成',
        no_actual: '実績データ待ち',
        vs_target: '{{year}}年目標比',
        base: '基準年（{{year}}）',
        actual: '実績（{{year}}）',
        target: '目標（{{year}}）',
      },
      empty: {
        title: 'まだ排出量データがありません',
        body: '排出量を登録すると、Scope別の内訳・月別推移・拠点別比較がここに表示されます。',
        register: '排出量を登録する',
        guide: '利用ガイドを見る',
      },
    },
    let_use_tanso_check: 'タンソチェックを使ってみよう',
    view_emission_intensity_new: '係数詳細閲覧',
    entering_cacbon_emission: 'エネルギー量の入力',
    view_emission_button: '排出原単位を見る',
    register_emission_button: '排出量を登録する',
    entering_cacbon_emission_des:
      '拠点の登録後、「排出量登録」に行き、排出原単位の確認後、排出量の登録をしましょう。',
    co2_status_check: 'エネルギー量を分析する',
    co2_status_check_button: 'CO2排出量を分析する',
    co2_status_check_des:
      '組織全体や各拠点のエネルギー量の状況を閲覧・分析してみましょう。',
    click_here_to_see_detail: '詳しい内容を知りたい方はこちら：',
    user_guide: '利用ガイド',
    faq: 'よくあるご質問',
    total_emissions: '組織全体の排出量',
    main_energy_data: '主要なエネルギーのデータ',
    total_emissions_group: {
      title: '組織全体の排出量',
      button_view: '排出量を詳しく見る',
      target_year: '算定年度',
      option_default: '全て',
      year: '年',
      financial_year: '年度',
      month: '月',
      scope_1: 'スコープ1',
      scope_2: 'スコープ2',
      scope_3: 'スコープ3',
    },
    information_table: {
      premium_require_single_line:
        'この機能はプレミアムプランのみ使用可能です。画像や書類管理が可能です。',
      premium_require_multi_line:
        'この機能はプレミアムプランのみ使用可能です。\n画像や書類管理が可能です。',
      premium_require_multi_line_sp:
        'この機能は\nプレミアムプランのみ使用可能です。\n画像や書類管理が可能です。',
      total: '全体合計',
      scope_3: 'スコープ3内訳',
    },
    direct_emissions: '直接排出',
    indirect_emissions: '間接排出',
    detail: '詳細',
    gasoline: 'ガソリン',
    city_gas: '都市ガス',
    diesel: '軽油',
    tap_water: '水道水の',
    paper: '紙の',
    scope1_Emissions: 'スコープ1排出量',
    scope2_Emissions: 'スコープ2排出量',
    top_3_factory: '排出要因ランキング',
    consumption_trend: 'スコープ1燃料種別消費量推移',
    change_in_purchases: 'スコープ2電気・蒸気等購入量推移',
    monthly_emissions: '月ごとの排出量推移',
    change_electricity_consumption: 'スコープ2の電気使用量・電気料金の推移',
    electricity_consumption: '電気使用量',
    electricity_charges: '電気料金',
    fuel_charges: '燃料料金',
    cost: '費用',
    changes_in_emissions_by_facility: '全施設の排出量の推移',
    coke: 'ガソリン',
    electricity: '電気',
    notification: '通知',
    text_demo:
      '※現在サービスリリース前のβ版になります。7月初旬に正式にリリースになります。デザインが大きく変わりますが、データは蓄積されますので、β版を引き続きご使用ください。',
    emissions_per_scope: 'スコープ別の排出量グラフ',
    changes_by_scope: 'スコープ毎の推移',
    other_data: 'その他データ',
    table: {
      scope: 'スコープ',
      category: 'カテゴリー',
      emission_tCO2e: {
        the_year_before_last: '{{theYearBeforeLast}}年排出量（tCO2e）',
        last_year: '{{lastYear}}年度排出量（tCO2e）',
        current_year: '{{currentYear}}年排出量（tCO2e）',
      },
      Scope1_Direct_emissions: 'スコープ1 直接排出',
      Scope2_Direct_emissions: 'スコープ2 間接排出',
      Scope3: 'スコープ3',
      purchase: '購入',
      premium: 'プレミアム\nプラン',
      Capital_Goods: '資本財',
      fuel_and_energy: 'その他燃料',
      upstream_transportation: '輸送（上流）',
      waste_generated: '事業廃棄物',
      bussiness_travel: '従業員の出張',
      employee_commuting: '従業員の通勤',
      upstream_leased_assets: 'リース資産（上流）',
      downstream_transportation: '輸送（下流）',
      processing_of_sold: '商品の加工',
      use_of_sold: '商品の使用',
      end_of_life: '商品の廃棄',
      Downstream_Leased_Assets: 'リース資産（下流）',
      Franchise: 'フランチャイズ',
      Investments: '投資',
      other: 'その他',
      total_scope3: 'スコープ3合計',
      total: '合計',
      rate_of_change: '増減率（前年対比）',
    },
    change_premium: 'プレミアムプランに\n 変更する必要があります',
    co2_emissions: 'CO2排出量',
    notifications: '運営局からのお知らせ',
    trivia: '豆知識',
    total: '合計',
    emission: '排出量',
    scope1: 'スコープ1',
    scope2: 'スコープ2',
    scope3: 'スコープ3',
    consumption_trends_by_fuel_types: '燃料種別消費量推移',
    scope1_consumption: 'スコープ１の費用の推移',
    scope3_consumption: 'スコープ３の費用の推移',
    posted_by: '作者:',
    date: '日付:',
    one_direct_emissions: '1 直接排出',
    two_direct_emissions: '2 間接排出',
    three_direct_emissions: '3 その他の間接排出',
    changes_in_the_amount_of: '電気・蒸気等購入量推移',
    cost_trends_by_fuel_types: '燃料費の推移',
    view_emission_intensity: '排出量単位を確認する',
    total_of_scope1: 'スコープ1 合計',
    total_of_scope2: 'スコープ2 合計',
    total_of_scope3: 'スコープ3 合計',
    changes_in_the_amount_Of_scope_3: 'スコープ3の購入量推移',
    cost_trend_scope_3_emission: 'スコープ3の料金の推移',
    main_energy: {
      gasoline: 'ガソリン使用量・ガソリン料金の推移',
      city_gas: '都市ガス使用量・都市ガス料金の推移',
      diesel: '軽油使用量・軽油料金の推移',
      tap_water: '水道水の使用量・水道水の料金の推移',
      paper: '紙の使用量・紙の料金の推移',
    },
    charge: '料金',
    consumption: '使用量',
    scopeTotal: '合計',
    total_emission_of_5_years: '過去5年の総排出量（tCO2e）',
    organization_wide_emissions: '組織全体の排出量（過去5年間）',
    scope1_dashboard: 'スコープ1',
    scope2_dashboard: 'スコープ2（マーケット係数）',
    scope2_location: 'スコープ2（ロケーション係数）',
    scope3_dashboard: 'スコープ3',
    total_dashboard: '合計（マーケット係数）',
    location_total: '合計（ロケーション係数）',
    market_based_coefficient: 'マーケット係数',
    location_based_coefficient: 'ロケーション係数',
    denkicheck_banner: {
      label: '排出量を減らす',
      title: '再エネへの切り替えで、CO2排出量と電気代を同時に削減。',
      description:
        'スコープ2の削減には電力の切り替えが有効です。デンキチェックで、いまの電気料金がどれだけ下がるかを無料で診断できます。',
      button: 'デンキチェックで診断する',
    },
  },
  analysis: {
    scope_description:
      '組織の中で排出されたもののうち、スコープ{{number}}に限定して分析することができます。',
    name_filter: '名称を入れてください',
    year_last: '年',
    month: '',
    month_last: '月',
    quarter: '',
    quarter_last: '期',
    search: '名称（任意）',
    title_target: '分析対象選択',
    select_from_company_or_location: '組織や施設／拠点から選択',
    select_from_group: 'グループから選択',
    placeholder_select_company: '組織を入力または選択してください。',
    placeholder_select_branch: '拠点を入力または選択してください。',
    placeholder_select_group: 'グループ名を入力または選択してください。',
    add_new_group: '新規グループを追加',
    title_target_year: '対象分析期間',
    option_target_year: {
      month_year: '算定期間',
      year: '算定年度',
    },
    facility_emissions_comparison: '施設ごとの排出量の比較',
    electric: '電力',
    tap_water: '水道水',
    all: {
      month: '年',
      year: '月',
      csv_download: 'CSV出力',
      pdf_download: 'PDF出力',
      total_emissions: 'CO2eの排出量の合計',
      total: '合計',
      filter_settings: 'フィルター設定',
      save_filter_settings: '設定フィルターを保存',
      pdf_output: 'PDF出力',
      filter_title: '分析条件',
      display_scope: '表示スコープ',
      display_year_month: '表示年月',
      monthly_display: '月別表示',
      annual_display: '年度表示',
      select_year: '年を選択',
      scope2_calculation_method: 'スコープ2の算定方法',
      market_based: 'マーケット基準',
      location_based: 'ロケーション基準',
      display_base: '表示拠点',
      select_from_base: '拠点から選択',
      select_from_group: 'グループから選択',
      select_base: '拠点を選択',
      use_saved_search_conditions: '保存した検索条件を使用する',
      table: {
        category: 'カテゴリー',
        scope: 'スコープ',
        co2: 'CO2排出量（tCO2e)',
        ratio: '割合',
        item: '品目',
        one_direct_emissions: '1 直接排出',
        two_direct_emissions: '2 間接排出',
        three_direct_emissions: '3 その他の間接排出',
        overall: '全体',
      },
      no_data_to_display:
        '表示するデータがありません。\nデータを登録して、もう一度確認してください。',
      no_data_in_period:
        '選択中の期間（{{from}}〜{{to}}）に該当するデータがありません。\n「フィルター設定」から対象期間を変更してください。',
      compare: '比較対象を追加',
      back_to_default: '比較をやめる',
      description: '組織全体の排出量を確認できます。',
      total_emissions_description: '総排出量の内訳',
    },
    scope1: {
      type_of_analysis: '分析の種類',
      target_year: '算定年度',
      csv_download: 'CSV出力',
      change_in_consumption: '燃料種別消費量推移',
      total_emissions: '総排出量',
      total_emissions_scope1: '総排出量  (スコープ1)',
      total_emissions_scope2: '総排出量  (スコープ2)',
      change_in_consumption_scope2: '電気・蒸気等購入量推移',
      total__co2_emissions: 'total CO2e emissions',
      city_gas: '都市ガス',
      gasoline: 'ガソリン',
      city_gas_liter: 'ガソリン（リットル）',
      gasoline_m3: '都市ガス (m3)',
      gasoline_nm3: '都市ガス(Nm3)',
      electricity: '電気',
      text_scope3:
        '契約プランではご利用いただけません。\n 契約プランの変更はお問い合わせください。',
      top_emission: '排出要因',
      emission: '排出量',
      diesel: '軽油',
      table: {
        year: '年度',
        year_title: '項目',
        item: '項目',
        category: 'カテゴリー',
        emission_intensity: '排出原単位',
        amount_to_use: '使用量',
        usage: '使用量',
        unit: '単位',
        individual: '個別CO2排出量\n（tCO2e）',
        co2_emissions: 'CO2排出量\n（tCO2e）',
        ratio: '割合',
        emission_facotr: '排出原単位',
        tco2_2021: '2021年度（tCO2e）',
        tco2_2022: '2022年度（tCO2e）',
        tco2_2023: '2023年度（tCO2e）',
        month: {
          month1: '1 月',
          month2: '2 月',
          month3: '3 月',
          month4: '4 月',
          month5: '5 月',
          month6: '6 月',
          month7: '7 月',
          month8: '8 月',
          month9: '9 月',
          month10: '10 月',
          month11: '11 月',
          month12: '12 月',
        },
        total: '料金',
      },
      changes_in_electricty: '電気使用量・電気料金の推移',
      changes_in_electricity_consumption_and_electricity_charges:
        '電気使用量・電気料金の推移',
      change_electricity_consumption: '電気使用量・電気料金の推移',
      scope: 'スコープ',
      all: '全て',
      direct_emissions_1: '1 直接排出',
      indirect_emissions_2: '2 間接排出',
      other_indirect_emissions: '3 その他の間接排出',
      monthly_emissions_trend: '月ごとの排出量推移',
      there_is_no_target: '対象データがありません。',
      select_organization: '対象組織データ回収率',
      enter_target:
        'アップロード機能から、対象データを入力してください。\nなお、分析のデータはアップロードの翌日よりご利用いただけます。',
      branch_name: '施設名',
      changes_in_emissions_by_facility: '全施設の排出量の推移',
      comparison_across_facilities: '全施設の排出量の比較',
      data_collection_check: 'データ回収チェック',
      fuel_charges: '燃料料金',
      total: 'スコープ1 合計',
      cost_trends_by_fuel_types: '燃料費の推移',
      total_emissions_breakdown: '総排出量の内訳',
      monthly_emission_trend: '月ごとの排出量推移(tCO2)',
    },
    scope2: {
      electricity_company: '電力会社',
      menu: 'メニュー',
      total: 'スコープ2 合計',
      total_electric: '他社から供給された電気の使用',
      total_industrial_stem: '他社から供給された熱の使用',
      emission_unit: '排出原单位',
      group_by: 'グループ化',
      group_by_item: '品目別',
      group_by_classification: '分類別',
      scope2_calculation_method: 'スコープ2の算定方法',
      market_based: 'マーケット基準',
      location_based: 'ロケーション基準',
      total_emissions_breakdown: '総排出量の内訳',
      monthly_emission_trend: '月ごとの排出量推移(tCO2)',
    },
    scope3: {
      total_emissions: '総排出量',
      changes_in_the_amount_Of_scope_3: 'スコープ3の購入量推移',
      cost_trends_by_scope3: 'スコープ3の料金の推移',
      scope3_category_overview: 'カテゴリーごとの排出量',
      scope3: 'スコープ3 合計',
      scope3_cost: 'スコープ3の料金',
      category_overview: 'カテゴリーごとの排出量',
      total_scope3: 'スコープ3 合計',
      emission_by_category: 'カテゴリーごとの排出量',
      total_emissions_breakdown: '総排出量の内訳',
      monthly_emission_trend: '月ごとの排出量推移(tCO2)',
    },
    other: {
      description:
        '排出量の多いものや、施設/拠点ごと、月、年ごとの排出量の推移を確認することができます。',
      changes_in_emissions_by_year: '年度ごとの排出量推移',
      main_energy_emission_trends: '主要エネルギーの排出量推移',
    },
  },

  report: {
    co2_emission_report: 'CO2排出量レポート',
    target_company: '対象場所',
    target_period: '対象期間',
    total_emissions: '総排出量',
    monthly_emission_trends: '月ごとの排出量推移',
    direct_emissions: '1 直接排出',
    indirect_emissions: '2 間接排出',
    other_emimissions: '3 その他の間接排出',
    description: '様々な分析のグラフを一覧で確認することができます。',
    table: {
      scope: 'スコープ',
      category: 'カテゴリー',
      note: '備考',
      FY2021: '年 排出量\n（tCO2e）',
      FY2022: '年 排出量\n（tCO2e）',
      FY2023: '年\nの排出量の割合',
      scope1_direct: 'スコープ1 直接排出',
      scope2_indirect: 'スコープ2 間接排出',
      total: '合計',
      export_to_pdf: 'PDFで出力する',
      item: '品目',
      growth: '増減率',
    },
    export_pdf: 'PDFで出力する',
    note: '備考',
    view_report: '表示する',
    scope3: 'スコープ3',
    category_overview: 'カテゴリーごとの排出量',
    total_scope_3: 'スコープ3 合計',
    total_of_scope3: 'スコープ3 合計',
  },
  contact: {
    inquiry_form: 'お問い合わせ',
    require: '必須',
    company_name: '組織名',
    fullName: '名前',
    plCompanyName: '株式会社タンソ',
    plFirstName: '山田',
    plLastName: '太郎',
    plBranch: '東京支社',
    plDepartment: 'CSR部',
    plJobTitle: '課長',
    plOthers:
      '利用するプレミアム機能の内容をご記入ください。（例）機能や料金プランについて詳しく教えてください。コンソーシアム機能について教えて欲しい。など',
    privacy_policy_text_link: '<1>個人情報保護方針<1>',
    privacy_policy_text: 'に同意の上でお進みください。',
    facility: '支店／ 施設',
    department: '部署名',
    jobTitle: '役職',
    phone: '直通の電話番号',
    subPhone: '※在宅勤務の方は携帯番号をご記入ください',
    email: 'メール アドレス',
    area: '利用するプレミアム機能',
    other_requires: 'お問い合わせの内容',
    note_other: 'お問い合わせの内容をご記入ください。',
    tansoCheck: {
      full: '個人情報保護方針に同意の上でお進みください。',
      first: 'By submitting this form, you agree to',
      second: 'TansoCheck’s Privacy Policy',
      third: ', and consent to receive TansoCheck marketing communications.',
    },
    send: '送信する',
    send_success:
      ' お問い合わせを受け付けました！ご入力いただいたメールアドレスに自動返信メールをお送りしております。',
    send_success_title: 'お問い合わせを受け付けました。',
    send_success_content:
      'ご記入頂いたメールアドレスへ、\n自動返信の確認メールをお送りしておりますのでご確認ください。',
    send_failure_title: 'お問い合わせの送信に失敗しました。',
    send_failure_content:
      '前の画面に戻り、内容をご確認の上\nもう一度「送信する」ボタンを押してください。',
  },
  upload: {
    do_you_want_to_delete: '選択された入力データを削除してもよろしいですか。',
    cancel: 'キャンセル',
    download_template: 'テンプレート：',
    registration: {
      from_image: '画像から排出量を新規登録する',
      by_manual: '入力して排出量を新規登録する',
      scope: 'スコープ',
      all: 'すべて',
      category: 'カテゴリー',
      key_word: 'フリーワード検索',
      key_word_placeholder: 'フリーワードで検索する',
      filtering: 'フィルター{{ status }}',
      emission_category: '炭素のスコープ',
      detail_information: '排出量の登録',
      upload_image: '書類アップロード（※請求書データ管理にご活用ください）',
      full_title: '拠点情報',
      require: '必須',
      scope2_factor: '電力はスコープ２です。',
      returnToTop: '排出量管理TOPへ戻る',
      return: '戻る',
      status: 'ステータス',
      registration_date: '登録日',
      select_date: '日付を選択',
      year_of_month: '使用年月',
      select_year_and_month: '年月を選択',
      clear: 'すべての条件をクリア',
      search: '検索する',
      apply: '適用',
      download: 'CSV出力',
      delete: 'チェックした行を削除',
      edit_registration: '登録データ編集',
      go_to_company_shared: '自社排出量を共有する',
      target_organization: '対象組織',
      additional_information: '補足',
      attachment: '添付ファイル ',
      image_upload: '画像一覧',
      manual_input: '入力一覧',
      about_us: '組織情報',
      label: {
        company_name: '組織名',
        facility: '施設／拠点',
      },
      note: '選択肢がない場合は<style>こちら</style>から拠点登録を行いましょう。',
      placeholder: {
        emissionName: '４Fの電気、社長の車など',
        supplier: '〇〇商事、〇〇電気など',
      },
      description: '組織で利用した排出量データを登録することができます',
      button: {
        to_list_registration: '排出量登録へ',
      },
      choose_file_upload: 'ファイルが選択されていません。',
      upload_excel_tab: 'インポート',
      history_upload_excel_tab: 'インポート履歴',
      history_upload_created: 'アップロード日',
      history_upload_dowload_csv: 'ファイル名',
      history_upload_name: 'スコープ',
      history_upload_total: '登録件数',
      history_upload_user: '登録ユーザー',
      history_upload_action: '登録されたデータ',
      show_data_upload: 'データを確認する',
    },
    table: {
      controlName: '管理番号',
      name: '名称',
      companyName: '組織名',
      facility: '施設／拠点',
      registerUser: '入力担当',
      registerDate: '登録日',
      year_of_month: '使用年月',
      scope: 'スコープ',
      category: 'カテゴリー',
      classification: '分類',
      item: '品目',
      type_of_ess: '排出原単位の種類',
      data_source: 'ソース',
      supplier: '取引先',
      amount: '活動量',
      paid_amount: 'ご請求金額 (円)',
      unit: '単位',
      co2: 'CO2排出量(tCO2e)',
      co2_market: 'CO2排出量(tCO2e)マーケットベース',
      co2_location: 'CO2排出量(tCO2e)ロケーションベース',
      menu: 'メニュー',
      attachment: '一括登録エクセルファイル',
      status: {
        status: 'ステータス',
        faild: '失敗',
        complete: '完了',
        inprogress: '対応中',
        incomplete: '未',
        scopes: {
          all: 'すべて',
          scope_1: '1 直接排出',
          scope_2: '2 間接排出',
          scope_3: '3 その他の間接排出',
        },
      },
      ghg: 'GHG',
      no_row_selected: '表示項目が何も選択されていません。',
      emission_factor_main: '排出係数',
      item_scope2: '電力会社/品目',
      emission_scope2: 'メニュー/排出原単位',
    },
    button: {
      delete: '削除',
      cancel: 'キャンセル',
      update: '更新',
      register_emissions: '個別登録',
      csv_upload: '一括登録',
      invoice_ocr: '請求書から登録(AI)',
      display_options: '表示項目 ({{selected}}/{{total}})',
      submit_checkbox: '表示項目を絞る',
      select_all: 'すべて選択',
      deselect_all: 'すべての選択を解除',
    },
    classification: {
      ethylene_production: 'エチレンの製造',
      use_of_acetylene: 'カルシウムカーバイドを原料としたアセチレンの使用',
      fuel_use: '燃料の使用',
      electricity: '電気',
    },
    items: {
      production_of_ethylene: 'エチレンの製造',
      use_of_acetylene: 'カルシウムカーバイドを原料としたアセチレンの使用',
      raw_coal: '原料炭',
      common_coal: '一般炭',
      coke: 'コークス',
      coal_tar: 'コールタール',
      gasoline: 'ガソリン',
      smokeless_coal: '無煙炭',
      petroleum_coke: '石油コークス',
      petroleum_asphalt: '石油アスファルト',
      electricity_2022: '電気(2022年度)',
      electricity: '電気',
    },
    types_of_emission_intensity: {
      production_of_ethylene: 'エチレンの製造',
      use_of_acetylene: 'カルシウムカーバイドを原料としたアセチレンの使用',
      raw_coal: '原料炭',
      common_coal: '一般炭',
      coke: 'コークス',
      coal_tar: 'コールタール',
      gasoline: 'ガソリン(L)',
      smokeless_coal: '無煙炭',
      petroleum_coke: '石油コークス',
      petroleum_asphalt: '石油アスファルト',
      electricity_2022: '原料炭',
      electricity: {
        electricity_1: '北海道電力(株)_メニューB（残差）',
        electricity_2: '東京電力エナジーパートナー(株)_メニューG（残差）',
        electricity_3: '北陸電力(株)_メニューC（残差）',
        electricity_4: '中部電力ミライズ(株)_(参考値)事業者全体',
      },
    },
    label: {
      display_options: '表示項目',
    },
    description: {
      scope_1:
        '自社が所有または管理する設備からの直接的な温室効果ガス排出。主に燃料の燃焼や工場・車両からの排出が該当します。',
      scope_2:
        '外部から購入した電気、蒸気、熱、冷房などのエネルギー使用に伴う間接的な排出。排出はエネルギー供給者側で発生します。',
      scope_3:
        '原材料の調達、製品の使用・廃棄、従業員の通勤や物流など、バリューチェーン全体で発生するその他の間接排出が対象です。',
    },
  },
  setting: {
    branch: {
      sub_title: '拠点情報',
      country: '国',
      company: '組織',
      branch: '施設／拠点',
      status: 'ステータス',
      public: '表示',
      do_you_want_to_delete: '削除してもよろしいですか。',
      private: '非表示',
      search_block: {
        placeholder: '拠点名を指定',
        btnText: '検索',
      },
      add_facility: '拠点を追加する',
      edit_facility: '拠点を編集する',
      electricity_company: '電力会社',
      choose_a_power_company: '電力会社を選択する',
      select_box_placeholder: {
        countries: '国を選択する',
      },
      guide_box: {
        guide_description: 'まだ拠点が登録されていたないため、',
        note: '<outline>「拠点を追加する」<inlineStyle></inlineStyle></outline>ボタンから拠点を登録してみましょう！',
        no_match_data: 'キーワードに該当する項目はありませんでした。',
      },
      edit: {
        title: '組織情報を編集する',
        submit_button: '招待する',
        placeholder: 'A工場、Aプラント',
      },
      all: '全拠点',
    },
    user: {
      list_title: 'ユーザー登録・権限',
      edit_title: 'メンバーを編集する',
      member_info: 'メンバー情報',
      affiliation: '所属',
      fullname: '氏名',
      fullname_kana: '氏名カナ',
      email: 'メールアドレス',
      password: 'パスワード',
      authority: '権限',
      status: '利用状況',
      split: '分割',
      company: '組織',
      branch: '施設／拠点',
      edit_discription: `※ユーザーの削除は、設定画面では行えません。利用停止に関しては、利用状況の「無効」を選択してください。`,
      search_block: {
        placeholder: '名前・メールアドレス・施設／拠点を指定',
        btnText: '検索',
      },
      add_user: 'メンバーを追加する',
      add_user_btn: '追加する',
      add_user_btn_title: 'メンバーを追加する',
      table_title: {
        full_name: '名前',
        mail_address: 'メールアドレス',
        branch: '施設／拠点',
        authority: '権限',
        resend_verification_email: '認証メール再送信',
        password_settings_status: 'パスワード設定ステータス',
        status: {
          configured: '設定済み',
          not_configured: '未設定',
        },
      },
      place_holder: {
        filter_name: 'フィルタ名を入力してください',
        first_name: '田中',
        last_name: '太郎',
        first_name_kana: 'タナカ',
        last_name_kana: 'タロウ',
        select_company: '組織を選択する',
        select_country: '国を選択する',
        select_branch: 'すべての拠点',
        email: '新しいメールアドレス',
        password: 'パスワード',
      },
      reinvite: '再招待する',
      notify: '登録メールアドレスに設定用のURLを再送信いたしました',
      no_item_search: '表示するデータがありません。',
      enter_8_digits:
        '※半角英文字・半角数字を組み合わせて、8桁以上入力してください',
      affiliation_infomation: '所属情報',
      sur_name: '姓',
      name: '名',
      sur_name_kana: 'セイ',
      name_kana: 'メイ',
      back_to_top: ' ユーザー管理TOPへ戻る',
      change_mail_modal: {
        title: 'メールアドレスの変更',
        sub_title:
          'メールアドレスの変更後、次の30日間は変更できません。\nメールアドレスが正しいことを確認してください。',
        email: '新しいメールアドレス',
        password: '確認のためにパスワードを入力してください',
        info: '変更後に新しいメールアドレスに確認メールが送信されます。',
        error: {
          email_exist: 'このメールは既に使用されています',
          password_incorrect: 'パスワードが正しくありません',
          change_email:
            '{{date}} {{time}}まではメールアドレスを変更できません。',
          prevent_new_request:
            'メールアドレスの変更リクエストを最近行いました。前回のリクエストから24時間以内には、新たな変更リクエストを行うことができません',
        },
      },
    },
  },
  emissions_detail: {
    view_emission_intensity: '係数詳細閲覧',
    scope: 'スコープ',
    classification: '分類',
    item: '品目',
    type_of_emission_intensity: '排出原単位の種類',
    input_unit: '入力単位',
    emission_factor_main: '排出係数',
    emission_factor_s1: '排出係数(副1)',
    emission_factor_s2: '排出係数(副2)',
    primary_data: '一次データ',
    updated_date: '更新日付',
    supplement: '補足',
    valid_period: '有効期間',
    primary_data_collected:
      '一次データ：算出者が自らの責任で、サプライヤーなどから収集したデータ',
    cancel: 'キャセル',
  },
  emission_intensity: {
    clear: '条件クリア',
    apply: '適用',
    scope: 'スコープ',
    scope1_select: '1 直接排出 ',
    scope2_select: '2 間接排出  ',
    no_data: '表示するデータがありません。',
    category: 'カテゴリー',
    target_year: '算定年度',
    scope_1: 'スコープ 1',
    scope_2: 'スコープ 2',
    scope_3: 'スコープ 3',
    tooltip: {
      scope_1:
        'スコープ 1(スコープ1)とは、自社での燃料使用や工業プロセスによる直接排出した温室効果ガスの排出量のことを指します。',
      scope_2:
        'スコープ2(スコープ2)とは、自社で他社から供給された電気、熱、蒸気を使用した事による間接排出の温室効果ガスの排出量です。',
      scope_3:
        'スコープ3(スコープ3)とは、製品の原材料調達から製造、販売、消費、廃棄に至るまでの過程において排出される温室効果ガスの量（サプライチェーン排出量）を指し、スコープ1（自社での直接排出量）・スコープ2（自社での間接排出量）以外の部分「その他の間接排出量」を指します。',
    },
    create_coefficients: '係数作成',
    table: {
      year: '算定年度',
      class_ification: '分類',
      item: '品目',
      type_of_emissions_intensity: '排出原単位の種類',
      datasource: 'ソース',
      category: 'カテゴリー',
      input_unit: '入力単位',
      emission_factor_main: '排出係数',
      emission_factor_market: '排出係数(マーケット係数)',
      emission_factor_location: '排出係数(ロケーション係数)',
      emission_factor_main_unit: '排出係数_単位',
      emission_factor_secondary: '排出係数(副)',
      emission_factor_secondary_unit: '排出係数(副)_単位',
      primary_data: '一次データ',
      update_date: '更新日付',
      ghg: 'GHG',
      emission_factor_location_amount: 'CO2排出量マーケット係数',
    },
    create_coefficients_scope3: 'スコープ{{number}}の係数新規作成画面',
    edit_coefficients_scope3: 'スコープ3の係数更新画面',
    classification: '分類',
    item: '品目',
    type_of_emissions_intensity: '排出原単位の種類',
    input_unit: '入力単位',
    emission_factor: '排出係数',
    datasource: 'ソース',
    note: '補足',
    valid_period: '有効期間',
    cancel: 'キャンセル',
    scope3_select: '3その他の間接排出',
    delete: '削除',
    add: '追加',
    update: '更新',
    select_date: '日付を選択',
    select_or_enter_to_create_new: '選択または入力して新規作成する',
    limit_number_decimal: '整数10桁まで、少数20桁まで入力可能',
    note_type_of_emission_intensity_1: '例：A重油、灯油',
    note_type_of_emission_intensity_2: '例：低圧電力、高圧電力、エコプラン',
    note_type_of_emission_intensity_3:
      '例：購入した商品、自社の輸送車、廃棄処理、出張、出勤',
    description:
      'タンソチェックで登録されている排出量の係数データを確認することができます。また、ユーザー様の必要に応じて、独自の係数データを登録することも可能です。',
    button: {
      to_emission_list: '排出原単位一覧へ',
    },
    placeholder: {
      source: '管理しやすいソース名を入れて活用ください',
    },
    in_use: '利用中',
    of_company: '独自係数',
    emission_type: '種別排出量',
    emission_version_title: '環境省ver3.4',
    emission_version_description:
      'タンソチェックでは、環境省が公開している<1>『サプライチェーンを通じた組織の温室効果ガス排出等の算定のための 排出原単位について（Ver.3.4）』</1>に基づき排出係数を準備させて頂いております。排出係数のデータソースの環境省ver3.4は、排出係数のバージョンを表しております。',
    emission_unit_title: '環境省（Nm3数値を参考）',
    emission_unit_description:
      '環境省の発表した係数に基づき作成している報告用の係数になります。係数の作成された背景ですが、環境省の発表している係数の単位のみでは報告が十分にできないことを考慮し、ユーザー様が普段利用している単位に合わせて作成しております。都市ガスのNm3係数を利用し、m3の係数を作成しています。',
    emission_shiping_title: '輸送費を含んだカテゴリー1の係数について',
    emission_shiping_description:
      'グローバルサプライチェーンを考慮した環境負荷原単位の係数の中で、排出係数が記載されていないものに関しては、弊社では省略して記載をしています。',
    emission_propane_title: 'プロパン・ブタン（体積ベース）',
    emission_propane_description:
      'こちらの係数では、一般的なLPガスの割合に合わせ算出をしています。環境省の係数をベースにプロパンを70%, ブタンを30%で製造した場合を想定して作成しております。',
    emission_policy_description:
      'タンソチェックで提供している排出原単位の係数のソースについて説明をしています。',
    emission_policy_btn: '排出原単位ポリシーへ',
  },
  manual_input: {
    register_btn: '連続して登録する',
    register_one_time_btn: '登録する',
    bulk_upload: '一括読み込み',
    add_one_line: '+ 1行追加',
    add_ten_line: '+ 10行追加',
    delete: 'チェックした行を削除',
    check_line: 'チェックした行をコピーして追加',
    name: '名称',
    suppliers: '取引先',
    emission_factor: '排出係数',
    emission_factor_location: '排出係数(ロケーション係数)',
    emission_factor_market: '排出係数(マーケット係数)',
    emissions_co2: 'CO2排出量(tCO2e)',
    year_month_of_use: '使用年月',
    select_year_and_month: '年月を選択',
    classification: '分類*',
    item: '品目*',
    type_of_emissions: '排出原単位の種類*',
    menu: 'メニュー*',
    activity: '活動量*',
    value: '活動量',
    unit: '単位',
    paid_amount: 'ご請求金額',
    factor_main_unit: '排出係数_単位',
    please_fill: '必須項目を入力してください。',
    register: '登録',
    tooltip: {
      scope:
        'スコープとは、温室効果ガスの排出量を測定する範囲のことを指します。',
      name: '自社が購入・取得した製品またはサービスの物量・金額データ',
      supplier:
        '自社が購入・取得した製品またはサービスに係る資源採取段階から製造段階までの排出量をサプライヤー名称',
      classification: '使用した燃料の分類',
      ghg: 'GHG((温室効果ガス)プロトコルとは、温室効果ガスの排出量を算定・報告する際の国際的基準のことです。企業はこの基準に沿って報告することで、信頼性のある情報開示が可能になります。スコープ1〜3までの区分が設けられており、原料調達から消費・廃棄まで、サプライチェーン全体の排出量を基準にしている点が特徴です。',
    },
    title_copy: 'のコピー',
    register_user: '入力担当',
    updated_user: '最終更新者',
    emission_amount_market: 'CO2排出量　マーケット係数',
    emission_amount_location: 'CO2排出量　ロケーション係数',
    emission_name: '排出原単位',
  },
  csv_input: {
    title_page: '一括登録',
    csv_upload: 'ファイルアップロード',
    button_upload: '登録する',
    button_remove: 'アップロードをキャンセル',
    uploaded: 'がアップロードされています。',
    note_1: '※Excelファイルであげていますか？',
    note_2:
      '※分類、品目、排出原単位の種類、GHG、排出係数、単位は正しいですか？',
    note_3:
      '※<1>排出原単位</1> 画面や <2>テンプレート</2> を参考に入力してください。',
    errors: {
      invalid_type: 'サポート外の拡張子ファイルが含まれています。',
      upload_success: 'ファイルをアップロードしました。',
      branch_not_found: {
        title: '「拠点情報」が存在しません',
        description:
          'CSVファイル内ではなく、この後ろのCSVで一括登録画面で選択された拠点情報が削除されています。再度読み込んで設定した後でもう一度CSVファイルをアップロードしてください。',
      },
      file_empty: {
        title: 'データが入っていないファイルがアップロードされました',
        description:
          'もう一度データの入っているファイルか確認して再度アップロードしてください。',
      },
      table_error: {
        title: '空のセルがあります',
        description:
          '以下の行の必須項目のセルが空になっています。入力して再度アップロードしてください。',
      },
      error_empty_cell: {
        title: '空のセルがあります',
        description:
          '以下の行の必須項目のセルが空になっています。正しく入力して再度アップロードしてください。',
      },
      error_format: {
        title: '形式が正しくないセルがあります。',
        description:
          '「使用年月」の形式は”yyyy/mm"です。\n「排出係数」と「活動量」と「ご請求金額」は半角数字です。\n「排出係数」か「使用年月」か「活動量」か「ご請求金額」の形式を正しく入力してください。',
      },
      error_branch_items: {
        title: '登録された電力会社を入力してください',
        description: '登録されている電力会社の中から入力してください。',
      },
      error_emission_not_found: {
        title: '正しい排出原単位の種類を入力してください',
        description:
          '「排出原単位」のページで一覧の中から排出原単位を入力してください。',
      },
      excel_template: 'Excelファイルのテンプレート形式が正しくありません。',
      usage_date_not_valid: '正しい日付を選択してください。',
      classification_not_valid: 'この分類は存在しません。',
      item_not_valid: 'この品目は存在しません。',
      emission_not_valid: 'この排出原単位は存在しません。',
      amount_not_valid: '半角数字を入力してください。',
      branch_not_valid: 'この施設／拠点が存在しません。',
      unit_not_valid: 'この単位は存在しません。',
      company_electric_not_exist: '電力会社が見つかりませんでした。',
      category_not_valid: 'カテゴリーは存在しません',
    },
    type_errors: {
      name: '名称',
      year: '使用年月',
      class: '分類',
      item: '品目',
      emission_intensity: '排出原単位の種類',
      ghg: 'GHG',
      emission_factor: '排出係数',
      amount: '活動量',
      unit: '単位',
      cost: 'ご請求金額',
      currency: '通貨',
    },
    modal: {
      upload_error: {
        title: 'エクセルファイル内のエラーを修正してください',
        button_confirm: 'もう一度アップロード',
      },
      error_unknown: {
        title: '原因不明のエラーで失敗しました',
        description:
          'お手数おかけしてしまい申し訳ございません。以下のボタンよりメールでお問合せください。\nもしくは画面右下のこのボタンよりお問い合わせください。',
        button_confirm: '問い合わせ',
      },
    },
  },
  image_upload: {
    file_here: 'ここにファイルを',
    drop_and_upload: 'ドロップしてアップロード',
    or: 'または',
    select_file: 'ファイル選択する',
    select_data_file: '請求ファイルを添付する',
    multi_file:
      'ファイルは5個まで選択できます。<1>JPEG・PNG・JPG・JFIF・HEIC・PDF</1>形式をサポートしています。1ファイルは10MBが上限となります。\n書類併せてアップロードし、入力データの適切な管理に役立てましょう！',
    multi_file_sp:
      'ファイルは5個まで選択できます。\n<1>JPEG・PNG・JPG・JFIF・HEIC・PDF</1>形式をサポートしています。\n1ファイルは10MBが上限となります。書類併せてアップロードし、入力データの適切な管理に役立てましょう！',
    valid_type_are: '',
    limit_file: '1ファイルは10MBが上限となります。',
    note: '【ご注意】',
    for_AI_upload:
      '画像アップロードは1画像/ファイルにつき、1活動データが登録されます。',
    use_bulk_reading: 'CSVによる一括アップロードは、',
    manual_input: '手動入力',
    to_register_multiple_data: 'の[一括読み込み]ボタンから行うことが可能です。',
    cancel: 'キャンセル',
    submit: '登録',
    format: '形式をサポートしています。',
  },
  change_password: {
    current_password: '現在のパスワード',
    new_password: '新しいパスワード',
    confirm_password: '新しいパスワード（確認用）',
    change: '変更',
    change_password: 'パスワードを変更',
    password_not_match: '入力したパスワードと一致していません。',
  },
  payment: {
    change_usage_plan: '利用プラン変更',
    starter_plan: 'スタートプラン',
    free: '0円',
    co2_emission_automatic: 'CO2排出量自動計算機能',
    current_plan: '現在のプラン',
    premium_plan: 'プレミアムプラン',
    automatic_registration: 'スコープ３の算定',
    monthly_charge: '通常価格: ',
    upgrage: 'アップグレード',
    downgraged: 'ダウングレードした ',
    confirming: '確認中',
    to_see_up_to: '',
    scope3: 'スコープ3',
    and_use_automatic: 'まで見える化AIによる自動計算を導入したい方はこちら！',
    downgrage: 'ダウングレード',
    success: '成功',
    error: '失敗',
    failure: '失敗',
    yen_month: '/月',
    admin_upgrage: 'ダウングレードするには、\n管理者にご連絡ください。',
    table: {
      payment_histoty: 'お支払い履歴',
      No: 'No',
      date: '日付',
      amount: '金額',
      currency: '通貨',
      status: 'ステータス',
      note: '備考',
      error_stripe: 'エラー内容',
    },
    bill_detail: 'クレジットカードで決済する',
    currency: '通貨',
    credit_debit_card: 'クレジットカード',
    usd: '米国ドル(USD)',
    jpy: '日本円',
    subscribe: '申し込む',
    upgrade_successful: 'アップグレードが成功しました。',
    take_advantage: 'プレミアムプランに切り替わりました！',
    ok: 'OK',
    upgrade_failed: 'アップグレードが失敗しました。',
    please_check_the_error: 'エラー内容を確認して、もう一度試してください。',
    error_detail: '【エラー内容】',
    do_you_want_to_downgrade:
      'プレミアムプランから無料プランへのダウングレードについて',
    cancel: 'キャンセル',
    premium_plan_features_will: `タンソチェックのプレミアムプラン機能をご利用いただきありがとうございました。以下のダウングレードに関する注意点をご確認の上、お進みください。
    ・ダウングレードをしても返金は出来ません。しかし、次の支払予定日までの間はプレミアムプランが使用できます。
    ・次の支払予定日を過ぎると全てのプレミアム機能のコンテンツを見ることができなくなります。
    ・ダウングレード後に再度アップグレードをしても、以前の有料箇所データはご使用できない可能性があります。ダウングレードにはご注意ください。
    ・更新を停めるには利用期限無効日の10日前に申告する必要があります。`,
    plan_info: {
      free: {
        tag: '初めての方向け',
        title: 'スタートプラン',
      },
      premium: {
        tag: 'プロの方向け',
        title: 'プレミアムプラン',
      },
      price: '¥ <style>{{price}}</style> /月',
      co2_emission_automatic: 'CO2排出量自動計算機能',
      analysis_function: '分析機能',
      report_function: 'レポート機能',
      user_management: 'アカウントスタッフ追加機能',
      scope_1_2_measure: 'スコープ1,2の計測',
      scope_3_measure: 'スコープ3の計測',
      document_management: '書類管理機能',
      report_creation: 'サステナビリティレポートの作成（機能追加予定）',
      grant_authority: '取引先への管理権限付与による見える化（機能追加予定）',
      co2_reduction: 'CO2削減実績と目標の設定（機能追加予定）',
      note: '※スコープ３をご希望の方はプレミアムプランに変更する必要があります。銀行振り込みでの変更をご希望の場合はお問い合わせください',
    },
  },
  message_error_stripe: {
    card_declined: 'カードが拒否されました',
    common: '不明なエラーが発生しました',
    require: 'カード情報を正しく入力してください',
    payment_outside:
      'ユーザーが直接に決済したので、プランが管理者に変更されました。',
  },
  error: {
    email_request_error:
      'トークンの有効期限が切れました。再度ログインして、新しいメール変更リクエストを作成してください。',
    not_found_404: '404エラー',
    not_premium:
      '契約プランではご利用いただけません。\n 契約プランの変更はお問い合わせください。',
    something_wrong: '問題が発生しました。',
    user_not_premium: 'このアカウントはプレミアムではありません。',
    permission_denied: 'アクセス許可がありません。',
    user_inactive: 'ユーザーは無有効です。',
    unauthorized: '無許可',
    network: 'ネットワークエラー',
    something_error_with_reload:
      'エラーが発生しました。ページをリロードして再試行してください。',
    ip_blocked:
      'このIPアドレスからのアクセスは許可されていません。\n許可されたIPアドレスからログインしてください。',
    delete_branch_has_users:
      '拠点にユーザーが登録されているため、削除できません。',
    branch_not_found:
      '選択した拠点が見つかりません。拠点を選び直してください。',
    branch_item_not_found:
      '選択した項目は、この拠点に登録されていません。拠点設定を確認するか、別の項目を選択してください。',
  },
  my_account: {
    page_title: 'アカウント',
    user_information: 'ユーザー情報',
    edit_button: 'マイアカウント情報編集',
    back_to_top: 'アカウントTOPへ戻る',
  },
  tutorial: {
    title: 'いつでもご確認できます',
    description:
      '使い方がわからない方、詳しい内容を知りたい方は、\n「アカウント > <to>チュートリアル</to>」\nからいつでもご利用いただけます。',
  },
  authority: {
    parent_user: '親ユーザー',
    manager: '管理（全拠点）',
    viewer: '閲覧',
    facility_management: '管理（所属拠点）',
    facility_viewer: '閲覧',
    data_registration: 'データ登録',
    description: {
      parent_user: 'すべての閲覧・編集・ユーザー追加ができます。',
      manager: 'すべての閲覧・編集・ユーザー追加ができます。',
      viewer: '与えられたユーザーは、すべての閲覧のみ可能です。',
      data_registration:
        '排出量のデータ登録のみ可能です。与えられたユーザーは、自身の登録データのみ表示・編集ができます。',
      facility_management:
        '与えられたユーザーは、所属している拠点に紐づいているデータの登録・閲覧・編集・削除ができます。※拠点追加はできません。同じ拠点のみ他ユーザーの追加が可能です。',
      facility_viewer:
        '与えられたユーザーは、ユーザーが所属している拠点のデータの閲覧のみ可能です。',
    },
  },
  subsidy: {
    title: 'ファイル管理',
    add_folder: 'フォルダ',
    upload_file: 'ファイルアップロード',
    table: {
      name: '名前',
      lastModified: '最終更新日',
    },
    modal: {
      create_title: '新しいフォルダ',
      rename_title: '名前を変更',
      placeholder: '2023年 SHIFT事業',
      add: '作成',
      rename: 'OK',
      cancel: 'キャンセル',
      loading: 'ファイルアップロード中...',
      upload_success: 'アップロードが完了しました。',
      folder_name_hint: '',
      error: {
        folder_name_empty: 'フォルダー名を入力してください。',
        file_name_empty: 'ファイル名を入力してください。',
      },
      confirmation: {
        heading: 'ファイル名が同じです',
        sub_heading:
          'ファイルを上書きをするか、新規ファイルとしてアップロードをするか選択してください。',
        options: {
          overwrite: '既存ファイルに上書きをする',
          upload_new: '新規ファイルとしてアップロード',
        },
      },
    },
    option: {
      download: 'ダウンロード',
      edit_name: '名前の変更',
      preview: 'プレビュー',
      move_to_trash: 'ゴミ箱に移動',
    },
  },
  formatFileName: '「{{fileName}}」',
  file_management: {
    garbage: {
      title: 'ゴミ箱',
      announcement: 'ゴミ箱内のアイテムは30日後に完全に削除されます。',
      empty_trash: 'ゴミ箱を空にする',
      name: '名前',
      deletionDate: '削除日',
      restoration: '復元',
      delete_forever: '完全に削除',
      show_file_location: 'ファイル場所を表示',
      delete_permanently_title: '完全に削除しますか？',
      delete_permanently_content: ' を完全に削除します。削除後復元できません。',
      empty_trash_content:
        'ゴミ箱内のすべてのアイテムを完全に削除します。削除後復元できません。',
      returnToTop: 'ファイル管理に戻る',
      empty_trash_failed_message_title: '削除に失敗しました',
      empty_trash_failed_message_content:
        'ゴミ箱内のすべてのアイテム削除が失敗しました。時間をおいてもう一度お試してください。',
    },
    option: {
      download: 'ダウンロード',
      edit_name: '名前の変更',
      preview: 'プレビュー',
      move_to_trash: 'ゴミ箱に移動',
    },
    message: {
      move_to_trash_success: 'ゴミ箱に移動しました。',
      no_trash: 'ゴミ箱は空です。',
      empty_trash_success: 'ゴミ箱内の全てのアイテムを完全に削除しました。',
    },
  },
  setting_password: {
    title: 'パスワード設定',
    confirm_password: 'パスワード（確認用）',
    placeholder: {
      please_input_password: 'パスワードを入力してください。',
    },
  },
  company: {
    general_title: '組織設定',
    own_company_setting: '組織情報の設定',
    group_management: 'グループ管理',
    own_company_setting_description:
      '組織情報の編集、拠点の登録、メンバーに編集権限を付与することができます。',
    group_management_description:
      '管理している組織をグルーピングして、管理することが出来ます。各組織を共同事業体毎に管理して、排出量データの分析に役立たせましょう。',
    about_us: '組織情報',
    code: '組織コード',
    tab_facility: '拠点設定',
    tab_user: 'メンバー設定',
    company_group: 'グループ名',
    invitation_status: '招待状況',
    button: {
      to_own_company_setting: '自社情報へ',
      to_group_management: 'グループ管理へ',
      own_company_setting: '自社設定',
    },
    invite_status: {
      current_company: '自社',
      approved: '連携済',
      pending: '承認待ち',
    },
    collaboration_shared: {
      in_integration: '連携済',
      not_integrated: '承認待ち',
    },
    invite_screen_title: '他社と連携する',
    invite_screen_description: '既にタンソチェックに登録している組織と連携する',
    invite_screen_note:
      '※タンソチェックに登録がない組織と連携する場合は、「<style>タンソチェックの招待を送る</style>」から招待を行ってください。',
    company_name_auto: '組織名（自動入力）',
    company_requested_modal_title: '組織連携をリクエストする',
    company_requested_modal_description:
      '送信内容に問題ないでしょうか？送信しますか？',
    invite_screen_send_invitation: 'タンソチェックの招待を送る',
    company_modal_send_invitation_title:
      'タンソチェックの招待を送信して組織連携を行いましょう',
    company_modal_send_invitation_subject:
      '他社をタンソチェックに招待して、Co2排出量を共有してみましょう。「文章をコピー」からメールで招待を送信しましょう。',
    company_modal_send_invitation_body: `{{companyName}}からCo2等の排出量の見える化を行うこと ができるタンソチェックへの招待が届いています。
{{companyName}}と組織連携をして、排出量を共有・管理しましょう。
下記URLから会員登録後、{{companyName}}との組織連携の招待を行いましょう。

会員登録はこちら：{{registerUrl}}
※こちらのURLから登録しますと、{{companyName}}からの組織連携の招待がタンソチェックのサービス内で届きます。`,
    company_modal_send_invitation_subject_auto:
      'からタンソチェックへの招待が届きました',
    copy_text: '文章をコピー',
    company_modal_send_invitation_copy: '文章をコピーしました。',
    company_modal_send_invitation_open_email: 'メールを開く',
    company_modal_copy_success: 'メールを開く',
    company_shared_title: '自社の排出量を共有する',
    company_shared_status: '自社排出量データ共有',
    calculation_basis: {
      revenue: '売上ベース',
      volume: '物量ベース',
    },
    company_shared_group: 'グループ名',
    company_shared_modal_title: '自社排出量データを共有します',
    company_shared_modal_content:
      '{{ companyName }}に対して自社排出量データを共有します。',
    company_button_accept_shared: '排出量データを共有する',
    company_button_shared: 'オン',
    company_button_not_shared: 'オフ',
    analysis_button: '排出量分析へ',
    register_data_button: '排出量一覧へ',
    edit: {
      placeholder: '組織名を入力してください',
    },
    label: {
      created_at: 'リクエスト日時',
      emission_amount: '取引先関係排出量(tCO2e)',
      calculation: '計算ベース',
      status_share: {
        requested: 'リクエスト済み',
        shared: '共有済み',
        stop: '停止',
      },
      request_share_title: '排出量データ共有のリクエスト',
      placeholder: {
        company_name: '組織名',
        branch: '施設／拠点を選択する',
      },
      description_total_emission_amount:
        '取引先関係排出量とは全体の排出量から、連携先企業にのみ関係する排出量を意味しています。\n参考計算式：排出量×出荷金額/総売り上げ高',
    },
    fiscal_year_start_month: '年度開始月',
  },
  facility: {
    base_name: '拠点名',
    country_name: '国',
    electric_companies: '電力会社',
    status: 'ステータス',
    form: {
      label: {
        base_name: '施設／拠点',
      },
      note: '※編集は可能ですが削除不可です。削除したい場合は<style>こちら</style>からお問い合わせください。',
    },
    more: '(多多...)',
    message: {
      copy_success: 'コピーが成功しました。',
      copy_fail: 'コピーが失敗しました。',
      pin_success: 'ピン留めが成功しました！',
      unpin_success: 'ピン留めを解除しました！',
      pin_fail: 'ピン留めに失敗しました！',
      unpin_fail: 'ピン留めの解除に失敗しました！',
    },
  },
  registration: {
    tab: {
      own_company: '組織',
      other_companies: '組織外',
    },
    scope2: {
      empty_data_power_companies_message:
        'まずは、拠点設定で電力会社を登録してください',
      group_label: {
        branch_power_companies: '拠点に登録されている電力会社',
        remaining: 'すべて',
      },
    },
  },
  notification: {
    button: {
      go_to_analysis: '分析へ',
      go_to_data: '他社の排出量一覧へ',
      share_emissions: '排出量を共有する',
      go_to_notification: '通知へ',
      go_to_detail_company: '自社の排出量一覧へ',
      go_to_shared_screen: '共有画面へ',
    },
    received_request: {
      title: '組織連携リクエストが届いています。',
      description: '通知画面より確認ください。',
    },
    modal: {
      title: '組織連携リクエストが届いています。',
      description: '承認するを押して、連携を開始してください。',
    },
    request: {
      title: '{{companyName}}から組織連携リクエストが届いています。',
      description:
        '{{companyName}}から組織連携の申請が来ました。下記ボタンより承認をして、排出量を共有しましょう。',
    },
    approved: {
      title: '{{companyName}}との組織連携が完了しました。',
      description:
        '{{companyName}}との組織連携が完了しました。下記から排出量を{{companyName}}に共有してみましょう。',
    },
    shared: {
      title: '[{{companyName}}]からCo2排出量データが共有されました。',
      description:
        '{{companyName}}からCo2排出量データが連携されました。下記ボタンから{{companyName}}のC02排出量データを閲覧・分析してみましょう。',
    },
    request_share: {
      title:
        '[{{companyName}}]から排出量データ共有のリクエストが届いています。',
      description: '年: {{year}}\nスコープ: {{scope}}',
    },
    update_share: {
      title: '[{{companyName}}]排出量データが更新されました。',
      sub_title: '詳細データは以下の通りです:',
      before: '変更前: ',
      after: '変更後: ',
    },
  },
  group_management: {
    title: 'グループ管理',
    not_affiliation: '未所属',
    button: {
      edit_group: '編集',
      create_group: '新規グループ追加',
      add_company: '組織を追加する',
    },
    modal: {
      create: {
        title: '新規グループ追加',
        select_group: '親グループ',
        input_name: 'グループ名',
        confirm: '追加する',
      },
      edit: {
        title: 'グループ名を編集',
        input_name: 'グループ名',
      },
      remove_group: {
        title: '確認',
        description: 'グループを削除してもよろしいですか。',
      },
      remove_company: {
        title: '確認',
        description: '組織を削除します。よろしいでしょうか。',
      },
      placeholder: {
        group_name: 'ABC市、△△△事業部、DFCエリア、〇〇工場',
      },
    },
    group: {
      title: 'グループ一覧',
      empty_data: 'グループはありません。',
      selected_location: '選択中の拠点',
    },
    select: {
      title: '「{{position}}」の組織一覧（{{count}}）',
      empty_data: 'グループに所属している組織はありません。',
      placeholder: '組織を選択する',
    },
    message: {
      create_group_success: 'グループを登録しました。',
      name_group_exist: 'グループ名は既に存在しています。',
      remove_group_success: 'グループを削除しました。',
      remove_company_success: '組織を削除しました。',
      edit_group_success: 'グループを編集しました。',
    },
  },
  title: {
    request_premium_form: '利用プラン変更依頼フォーム',
    other_company_data: '組織外排出量データ',
  },
  button: {
    to_request_management: '連携企業一覧へ',
    to_shared_emissions: '連携状況管理へ',
    add_new_invite: '新規連携リクエスト',
    add_new_request_share: 'データ共有リクエスト',
    confirm: '確認する',
    filter: 'フィルター',
    set_base_year: '基準年度設定へ',
    save: '保存する',
    to_setting_screen: '設定画面へ',
    analyzing_total_emissions: '総排出量を分析',
    scope_analysis: 'スコープ{{number}}を分析',
    other_analysis: 'その他の分析',
    report_analysis: 'レポートページへ',
    external_emission_data: '組織外排出量データへ',
    update_filter: '設定を更新',
    filter_data: 'フィルターを実行',
  },
  share_management: {
    title: '連携状況管理',
    tab: {
      share_request: 'リクエスト一覧',
      share_emission: '共有管理一覧',
    },
    placeholder: {
      year: '年を選択してください',
    },
    shared_management_title: '連携管理',
    request_management_title: '連携企業一覧',
    request_management_description:
      '過去にリクエストをした企業のリクエスト状況を確認でき、また新規の連携先を追加することができます。',
    shared_emissions_title: '連携状況管理',
    shared_emissions_description:
      '連携をしている企業および共有状況を確認できます。データ共有のステータスの確認や個別での排出量の数値を確認することができます。',
  },
  usage_plan: {
    title: '利用プラン変更',
    sub_title:
      '利用したいプランを添えて、下記のページより問い合わせをしてください。',
    info: {
      tag: {
        standard: 'Standard',
        premium: 'Premium',
        using: '利用中',
      },
      standard: {
        price: 'スタンダード',
        description:
          '※こちらのプランでは無料で以下の機能を利用することができます。',
      },
      premium: {
        price: 'プレミアム料金',
        description:
          '※料金は企業様の利用用途・規模に応じて対応しております。詳細は「利用する」よりお問い合わせください。',
      },
    },
    feature: {
      scope_1_3: 'スコープ1-3対応',
      co2_automatic_calculation: 'CO2排出量自動計算機能',
      analysis: '分析機能',
      report: 'レポート機能',
      staff_account: 'アカウントスタッフ追加機能',
      document_management: '書類管理機能',
      consortium: 'コンソーシアム機能（他社データ連携機能）',
      csv_export: 'CSVエキスポート',
      target: '目標管理機能',
    },
    button: {
      use: '利用する',
    },
  },
  goal: {
    title: {
      reduction_normal_create: '独自の削減対策登録画面',
      reduction_filter_create: '削減対策登録画面',
      version_list: '削減数値設定',
      table_version_list: '目標設定ファイル',
      reduction_plans_for_each_scope: '削減予測イメージ',
      version_detail: '目標管理の作成',
      version_edit: '目標管理の編集',
    },
    label: {
      scope: 'スコープ',
      version: 'バージョン',
      unique_reduction_measures: '独自の削減対策',
      reduction_measures: '削減対策対象',
      reduction_measures_detail: '削減対策詳細',
      reduction_measures_items: '削減対策項目',
      avoided_emission: '削減貢献量（tCO2e）',
      reduction_measures_target: '削減対策対象',
      scope_1: 'スコープ1',
      city_gas: '都市ガス',
      kerosene: '灯油',
      gasoline: 'ガソリン',
      light_oil: '軽油',
      scope_2: 'スコープ2',
      purchased_electricity: '購入電力',
      start_year: '開始年',
      reduction_effect_of_investment: '投資による削減効果（円）/ 年',
      status: 'ステータス',
      on: 'オン',
      off: 'オフ',
      search_for_reduction_measures: '削減対策',
      products_services: '削減対策プロダクト/サービス',
      co2_avoided_amount: '導入による削減貢献量（tCO2e）',
      version_name: 'バージョン名',
      target_setting_period: '目標設定期間',
      creation_date_time: '作成日時',
      target_activity: '活動目標',
      total_emissions_base_year: '基準年度の総排出量 [tCO2e]',
      registered_co2_reduction_measures: '登録済みのCO2削減対策',
      branch: '施設／拠点',
      type: '種別',
      operation: '操作',
      scope_numbers: '数値でみる',
      graph: 'グラフでみる',
      goal_setting: '目標設定',
      planned_value_optinal: '計画数値',
      base_year_and_target_end_year_required:
        '※基準年度と目標設定の最終年度を入れてください。',
      production_increase_rate: '生産量増加率：',
      bases_creation_completed_version: '拠点のバージョン',
      version_status_description:
        '拠点ごとに「作成完了」状態の目標設定は1つだけです。\n他の目標設定を「作成完了」に変更した場合、現在「作成完了」に設定されている目標設定は「作成中」に変更されます。',
      plan: 'スコープ1, スコープ2 (削減対策がない場合)',
      unit: '単位 ({{ unit }})',
      total: '合計',
      cutoff_table_title: 'CO2削減合計値',
      plan_after: 'スコープ1, スコープ2 (計画)',
      co2_emission_rate: 'CO2排出率',
      growth_rate: '生産量増加率',
      carbon_productivity: '炭素生産性',
      detail: '詳細',
      imagine_finished_product: '完成をイメージしましょう！',
      re_measures: '削減対策',
      re_measures_with_unit: '削減対策対象（tCO2e）',
    },
    placeholder: {
      reduction_measures: 'エアコンの省エネ型への交換',
      reduction_measures_detail:
        '古いエアコンを最新の省エネ型に更新することで、消費電力を大幅に削減し、それに伴うCO2排出量を減らすことができます。',
      reduction_effect_of_investment: '-1,200,000円',
      please_select: '選択してください。',
      scope: '削減対策対象を選択するとスコープが表示されます。',
      target: '削減対策対象の内容を検索してください。',
      filter: '削減対策、施設/拠点...',
      goal_version_name: '例：2024年度目標設定',
      sample_target: '2030年までに排出量を半分にする！',
      sub_sample_target: '※中長期的なスローガンをこちらで記載しましょう！',
      sub_sample_year: '※目標設定の最終年度を入れてください。',
      search_reduction_measures: '削減対策の内容を検索してください。',
    },
    button: {
      register: '登録',
      search_for_reduction_measures: '削減対策を検索',
      add_your_own_reduction_measures: '独自の削減対策を追加',
      create_goal_version: 'バージョンを追加する',
      to_the_list: '一覧画面へ',
    },
    message: {
      no_cutoff_data: '削減対策を追加しましょう。',
      no_cutoff_data_with_link:
        '<span><a>削減対策</a>を追加しましょう。</span>',
      no_data: 'データはありません',
      emission_strategy_exist: 'この削減対策は既に登録されています。',
      plan_is_required: '計画数値を入力してください。',
      no_version: 'バージョンはありません',
      no_search_data: '絞り込み結果がありません。',
      version_completed_is_required:
        '「作成完了」ステータスを持つ削減目標を登録してください。',
      viewer_version_completed_is_required:
        '親ユーザーの拠点で削減目標が設定されていません',
      version_branch_is_required: 'バージョンを作成してください。',
      exceed_length_name_version:
        'バージョン名は100文字以内でご入力してください。',
    },
    version_status: {
      preparing: '作成前',
      in_progress: '作成中',
      completed: '作成完了',
    },
    dashboard: {
      step: {
        title_completed_image: 'CO2削減目標の事例を見る',
        description_completed_image:
          '削減目標の設定が終わったらどんなふうに見えるかまずは、例を確認して見ましょう。',
        button_completed_image: '削減目標の完成例を見る',
        title_reduction_numbers: 'CO2削減対策一覧を見る',
        description_reduction_numbers:
          'CO2削減対策のメニュー例を確認し、記入した際のイメージをして見ましょう。',
        button_reduction_numbers: 'CO2削減対策一覧を見る',
        title_reduction_measures: 'CO2削減イメージを見る',
        description_reduction_measures:
          '削減計画の数値と削減対策を実施した際の数値をイメージして見ましょう。',
        button_reduction_measures: 'CO2削減イメージを見る',
      },
      sections: {
        title_reduction_number_setting: 'STEP1: 削減数値設定',
        description_reduction_number_setting:
          'CO2排出量の削減に向けて、自社でできる削減対策の具体的な内容を登録していきましょう。ここで登録した内容は繰り返し利用でき、毎年の削減対策レポートでも利用できるようになります。',
        title_scope_reduction_plan: '削減対策計画',
        demo_title_scope_reduction_plan: '完成例のデモページ',
        step_2_title_scope_reduction_plan: 'STEP2: 削減対策計画',
        description_scope_reduction_plan:
          'CO2排出量の削減に向けて、自社でできるスコープごとの削減計画を立てましょう。こちらではガス・電気などの使用量を減らすための数値設定をできるようになっています。',
        title_reduction_forecast_simulation: 'STEP3: CO2削減予測イメージ',
        description_reduction_forecast_simulation:
          '上記の現在の排出量データと削減対策を元に、削減対策全体の予測数値を確認することができます。',
      },
    },
    chart: {
      co2_reduction_plan: 'CO2削減計画',
      scope_1_plan: 'スコープ1 (計画)',
      scope_2_plan: 'スコープ2 (計画)',
      scope_1_actual: 'スコープ1 (実績)',
      scope_2_actual: 'スコープ2 (実績)',
      company: '全社',
      facility: '拠点',
      carbon_productivity_plan: '炭素生産性計画',
      co2_emission_rate: 'CO2排出率',
      production_increase_rate: '生産量増加率',
      carbon_productivity: '炭素生産性（生産量増加率/CO2排出率）',
    },
  },
  placeholder: {
    filter: 'フィルター',
    date: 'YYYY/MM/DD',
  },
  item: {
    create: {
      form: {
        title: '新規作成画面',
        name: {
          label: '品目',
          place_holder: '全国平均排出係数',
        },
        class: {
          label: '分類',
        },
      },
    },
  },
  pagination: {
    total:
      '全 <big>{{totalItems}}</big> 件中 <big>{{firstItem}}</big>~<big>{{lastItem}}</big> 件を表示',
    display_number: '表示件数',
  },
  invoice_ocr: {
    title: '請求書から登録(AI読み取り)',
    sub_title:
      '電気・ガス・燃料などの請求書をアップロードすると、AIが使用量を読み取って登録内容を作ります',
    step_scope: '1. 請求書の種類',
    scope1: 'Scope1(ガス・燃料)',
    scope2: 'Scope2(電気・熱)',
    scope3: 'Scope3',
    step_branch: '2. 拠点(任意)',
    branch_hint:
      'すべて同じ拠点の請求書なら指定してください。指定しない場合は、宛名や使用場所からAIが拠点を推定します。',
    branch_auto: 'AIに推定させる',
    branch_label: '拠点',
    usage_month: '使用年月',
    step_upload: '3. 請求書をアップロード',
    drop_here: 'ここに請求書をドロップ',
    drop_note: 'PDF・JPG・PNG・HEIC(10MBまで)',
    remove: '外す',
    read_button: 'AIで読み取る',
    reading: '読み取り中…',
    reset: 'やり直す',
    note_1:
      '・読み取りにはAIを使用します。1ファイルあたり10〜30秒ほどかかります(一度に20ファイルまで)。',
    note_2:
      '・読み取った内容はまだ登録されません。下の表で確認・修正してから「登録」してください。',
    note_3:
      '・アップロードした請求書は、登録した排出量データに証憑として添付されます。',
    check_title: 'AI読み取り結果の確認ポイント',
    check_hint:
      '赤字の項目と、確度が「低」の行は必ず確認してください。修正は下の表で行えます。',
    col: {
      file: '請求書',
      read: '読み取った内容',
      factor: '当てはめた係数',
      confidence: '確度',
      points: '確認ポイント',
    },
    confidence: {
      high: '高',
      medium: '中',
      low: '低',
    },
    status: {
      waiting: '未読み取り',
      reading: '読み取り中',
      done: '完了',
      warning: '要確認',
      error: '失敗',
      rows: '{{count}}件の登録内容を作成しました',
    },
    errors: {
      too_many: '一度に読み取れるのは{{max}}ファイルまでです',
      ai_failed: 'AIの読み取りに失敗しました。時間をおいて再度お試しください',
      unknown: '読み取りに失敗しました',
    },
  },
}
